import { useState } from 'react';

interface ShareButtonProps {
  title: string;
  className?: string;
}

export default function ShareButton({ title, className = '' }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({ title, text: title, url });
        return;
      }
    } catch {
      // user cancelled, fall through to copy
    }
    try {
      await navigator.clipboard.writeText(`${title} ${url}`);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap ${className}`}
    >
      <i className={copied ? 'ri-check-line text-accent-500' : 'ri-share-forward-line'}></i>
      {copied ? '链接已复制' : '分享'}
    </button>
  );
}